/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCreateCaseNoteDraft
 */
export interface InternalApiCreateCaseNoteDraft {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateCaseNoteDraft
     */
    content: string;
}

/**
 * Check if a given object implements the InternalApiCreateCaseNoteDraft interface.
 */
export function instanceOfInternalApiCreateCaseNoteDraft(value: object): value is InternalApiCreateCaseNoteDraft {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCreateCaseNoteDraftFromJSON(json: any): InternalApiCreateCaseNoteDraft {
    return InternalApiCreateCaseNoteDraftFromJSONTyped(json, false);
}

export function InternalApiCreateCaseNoteDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateCaseNoteDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function InternalApiCreateCaseNoteDraftToJSON(json: any): InternalApiCreateCaseNoteDraft {
    return InternalApiCreateCaseNoteDraftToJSONTyped(json, false);
}

export function InternalApiCreateCaseNoteDraftToJSONTyped(value?: InternalApiCreateCaseNoteDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

